import { PersonConfigFileType } from '@enums/person-config-file-type.enum';

export interface PersonConfigFileJson {
  id: number;
  name: string;
  type: PersonConfigFileType;
  title: string | null;
}

export class PersonConfigFile {
  file: File | null = null;
  constructor(
    public id?: number,
    public name?: string,
    public type?: PersonConfigFileType,
    public title?: string | null
  ) {}

  static fromJson(json: PersonConfigFileJson): PersonConfigFile {
    return new PersonConfigFile(json.id, json.name, json.type, json.title);
  }

  static toJson(file: PersonConfigFile): PersonConfigFileJson {
    return {
      id: file.id,
      name: file.name,
      type: file.type,
      title: file.title
    };
  }
}
